import { ErroDaApi } from '../api/cliente.ts';

/**
 * A recusa da API, dita por inteiro.
 *
 * Uma validação recusada chega com `mensagem: "Dados inválidos."` e a lista do
 * que de fato falhou em `problemas`. Mostrar só a mensagem deixa quem
 * preencheu sem saber qual campo a API não aceitou — e o formulário parece
 * quebrado em vez de recusado.
 *
 * Mora fora de `Superficie.tsx` porque conhece o cliente da API: as peças de
 * lá são só aparência, e não devem saber como uma chamada falha.
 */
export function RecusaDaApi({
  erro,
  padrao,
}: {
  erro: unknown;
  /** O que dizer quando a falha não veio da API, como uma queda de rede. */
  padrao: string;
}): React.JSX.Element | null {
  if (!erro) return null;

  const daApi = erro instanceof ErroDaApi ? erro : null;
  const problemas = daApi?.problemas ?? [];

  return (
    <div role="alert" className="mt-3 rounded-lg bg-erro/10 px-3 py-2 text-sm text-erro">
      <p>{daApi ? daApi.message : padrao}</p>
      {problemas.length > 0 ? (
        <ul className="mt-1 list-disc pl-4 text-xs">
          {problemas.map((problema) => (
            <li key={`${problema.campo}-${problema.mensagem}`}>
              {problema.campo === '(raiz)'
                ? problema.mensagem
                : `${problema.campo}: ${problema.mensagem}`}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
